export default {"src":"/_next/static/media/ArcBottomRightRed.9a4fa931.svg","height":8,"width":7,"blurWidth":0,"blurHeight":0};